export default "__VITE_ASSET__DHJlR2kR__"